<template>
  <div>
    <form class="inquiries-form" @submit.prevent="onSubmitForm">
      <div>
        <div class="font-bold mb-1">
          {{ $i18nPresenter.t('Your name') }}
        </div>
        <aha-input
          type="text"
          required
          v-model="formData.name"
        />
      </div>
      <div>
        <div class="font-bold mb-1">
          {{ $i18nPresenter.t('Work email') }}
        </div>
        <aha-input
          type="email"
          required
          v-model="formData.email"
          :placeholder="$i18nPresenter.t('name@yourcompany.com')"
        />
      </div>
      <div>
        <div class="font-bold mb-1">
          {{ $i18nPresenter.t('Phone number (optional)') }}
        </div>
        <aha-input
          type="tel"
          v-model="formData.phone"
          :placeholder="$i18nPresenter.t('+0 (123) 456-789')"
        />
      </div>
      <div>
        <div class="font-bold mb-1">
          {{ $i18nPresenter.t('Job title (optional)') }}
        </div>
        <aha-input
          type="text"
          v-model="formData.jobTitle"
        />
      </div>
      <div class="full-w">
        <div class="font-bold mb-1">
          {{ $i18nPresenter.t('Number of presenters') }}
        </div>
        <aha-select
          v-model="formData.quantity"
          required
        >
          <aha-select-option
            value=""
            disabled
            selected
            hidden
          >
            {{ ($i18nPresenter.t('Select')) }}
          </aha-select-option>
          <aha-select-option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </aha-select-option>
        </aha-select>
      </div>
      <div class="full-w">
        <div class="font-bold mb-1">
          {{ $i18nPresenter.t('Message (optional)') }}
        </div>
        <aha-textarea
          v-model="formData.message"
          class="text-area"
          :placeholder="$i18nPresenter.t('How can our Enterprise team help you?')"
          :max-length="500"
        />
      </div>
      <div class="inline-flex justify-between full-w">
        <aha-button-link type="button" class="justify-left" @click="toEnterprisePage">
          <span class="flex items-center gap-1">
            {{ $i18nPresenter.t('Learn more') }}
            <aha-icon
              class="icon"
              name="open-new-window"
              viewBox="0 0 24 24"
              width="17"
              height="17"
            />
          </span>
        </aha-button-link>
        <aha-button
          name="submit-enterprise-inquiry"
          v-aha-emit-action
          tabindex="0"
          type="submit"
          class="submit-request"
          :disabled="submitting"
          :submitting="submitting"
        >
          <span class="pl-4 pr-4">{{ $i18nPresenter.t('Submit') }}</span>
        </aha-button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'EnterpriseInquiriesForm',
  props: {
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitting: false,
      options: [
        {
          value: '1-10',
          label: '1-10',
        },
        {
          value: '11-50',
          label: '11-50',
        },
        {
          value: '51-100',
          label: '51-100',
        },
        {
          value: '101-250',
          label: '101-250',
        },
        {
          value: '250-1000',
          label: '250-1000',
        },
        {
          value: '1000+',
          label: '1000+',
        },
      ],
      formData: {
        name: '',
        email: this.email,
        phone: '',
        jobTitle: '',
        quantity: '',
        message: '',
      },
    }
  },
  methods: {
    ...mapActions(['submitEnterpriseInquiriesFormAction']),
    toEnterprisePage() {
      // open new window
      window.open('https://ahaslides.com/enterprise/', '_blank')
    },
    mapFormData(payload) {
      const {
        name, email, phone, jobTitle, quantity, message,
      } = payload
      return {
        inquirerName: name,
        workEmail: email,
        phoneNumber: phone,
        jobTitle,
        numberOfPresenters: quantity,
        message,
      }
    },
    async onSubmitForm() {
      this.submitting = true
      const submitData = this.mapFormData(this.formData)
      await this.submitEnterpriseInquiriesFormAction(submitData)
      // for iframe
      if (window.parent) {
        window.parent.postMessage({
          action: 'submitted-enterprise-inquiries-form',
        }, '*')
      }
      this.$emit('submittedForm')
    },
  },
}
</script>
<style scoped lang="scss">
.inquiries-form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;

    & .full-w {
        grid-column: span 2;
    }

    @media (max-width: 600px) {
        & > * {
            grid-column: span 2;
        }
    }

    &::v-deep .aha-textarea {
      margin-top: 0;
      margin-bottom: 0;
    }
}
</style>
